import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const ServiceSidebar = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <div className="services-sidebar">

      {/* ✅ SEO Heading */}
      <h2>IVF & Fertility Services in Ambala</h2>

      <ul>

        <li className={isActive('/services/iui') ? 'active' : ''}>
          <Link to="/services/iui" title="IUI Treatment in Ambala">
            IUI Treatment
          </Link>
        </li>

        <li className={isActive('/services/ivf') ? 'active' : ''}>
          <Link to="/services/ivf" title="IVF Treatment in Ambala">
            IVF Treatment
          </Link>
        </li>

        <li className={isActive('/services/icsi') ? 'active' : ''}>
          <Link to="/services/icsi" title="ICSI Treatment for Male Infertility">
            ICSI Treatment
          </Link>
        </li>

        <li className={isActive('/services/oocyte') ? 'active' : ''}>
          <Link to="/services/oocyte" title="Oocyte Pickup IVF Procedure">
            Oocyte Pickup
          </Link>
        </li>

        <li className={isActive('/services/embryo') ? 'active' : ''}>
          <Link to="/services/embryo" title="Embryo Transfer IVF Procedure">
            Embryo Transfer
          </Link>
        </li>

        <li className={isActive('/services/donor') ? 'active' : ''}>
          <Link to="/services/donor" title="Egg Donor IVF Program">
            Egg Donor Program
          </Link>
        </li>

        <li className={isActive('/services/gynae') ? 'active' : ''}>
          <Link to="/services/gynae" title="Gynaecologist in Ambala">
            Obstetrics & Gynae
          </Link>
        </li>

        <li className={isActive('/services/pediatrics') ? 'active' : ''}>
          <Link to="/services/pediatrics" title="Pediatrician in Ambala">
            Pediatrics
          </Link>
        </li>

      </ul>

    </div>
  );
};

export default ServiceSidebar;